import { isDefined } from "@clipboard-health/util-ts";
import { useSession } from "@src/appV2/Auth/api/useSession";
import { useGetAllChildWorkplaces } from "@src/appV2/FacilityProfile/api/useGetAllChildWorkplaces";
import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";
import { getWorkplaces } from "@src/appV2/Placements/utils/workplace";
import { useMemo } from "react";

export function useManagedWorkplaces() {
  const { profile } = useSession();
  const isParentManagedPlacementsEnabled = useCbhFlag(
    CbhFeatureFlag.ROLLOUT_PARENT_MANAGED_PLACEMENTS,
    { defaultValue: false }
  );

  // get the child facilities
  const {
    data: childWorkplaces,
    isLoading: isGetChildWorkplacesLoading,
    isSuccess: isGetChildWorkplacesSuccess,
  } = useGetAllChildWorkplaces(
    {
      parentFacilityId: profile?.userId,
    },
    {
      enabled: isDefined(profile?.userId) && Boolean(isParentManagedPlacementsEnabled),
    }
  );
  const workplaces = useMemo(
    () =>
      getWorkplaces({
        profile,
        isParentManagedPlacementsEnabled,
        isGetChildWorkplacesSuccess,
        childWorkplaces,
      }),
    [profile, isParentManagedPlacementsEnabled, isGetChildWorkplacesSuccess, childWorkplaces]
  );
  return { workplaces, isWorkplacesLoading: isGetChildWorkplacesLoading };
}
